import { useContext } from 'react';
import ModalContext from '../MakeAppointmentModal/ModalProvider';
import './DoctorsPreview.css';
import { checkRU } from '../../index';

const DoctorsPreview = ({ doctor }) => {
    const { isRu, apiUrl } = checkRU();
    const { modalOn, modalData } = useContext(ModalContext);

    const BUTTON_TEXT = isRu ? "ЗАПИСАТЬСЯ НА КОНСУЛЬТАЦИЮ" : "ЗАПИСАТИСЯ НА КОНСУЛЬТАЦІЮ";

    const onClick = () => {
        isRu ? modalData("Консультация - " + doctor.name, BUTTON_TEXT) : modalData("Консультація - " + doctor.name, BUTTON_TEXT);
        modalOn();
    };

    return (
        <div className="doctor-container-preview">
            <div className="doctor-shadow"></div>
            <button onClick={onClick} className="doctor-hidden-button">
                <div className="doctor-container-data">
                    <img src={doctor.image} className="doctor-image-preview" />
                    <h2>{doctor.name}</h2>
                    <div className="doctor-field">{doctor.field}</div>
                    <h4 className="doctor-preview-h">{isRu ? "Специализация" : "Спеціалізація"}</h4>
                    <div>{doctor.specialization}</div>
                    <h4 className="doctor-preview-h">{isRu ? "Опыт медицинской практики" : "Досвід медичної практики"}</h4>
                    <div>{doctor.experience}</div>
                </div>
            </button>
        </div>
    );
};

export default DoctorsPreview;